"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[13814],{

/***/ 28456:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "AY": function() { return /* binding */ newRegisterTypes; },
/* harmony export */   "E8": function() { return /* binding */ registerTypes; },
/* harmony export */   "HH": function() { return /* binding */ emailVerifyStatus; },
/* harmony export */   "Io": function() { return /* binding */ mappingNewRegisterTypes; },
/* harmony export */   "N3": function() { return /* binding */ errorMessage; },
/* harmony export */   "b_": function() { return /* binding */ LS_PHONE_REGISTER; },
/* harmony export */   "cs": function() { return /* binding */ emailStatuses; },
/* harmony export */   "eP": function() { return /* binding */ hints; },
/* harmony export */   "hb": function() { return /* binding */ LS_EMAIL_REGISTER; },
/* harmony export */   "o_": function() { return /* binding */ formTypes; },
/* harmony export */   "w7": function() { return /* binding */ phoneVerifyStatus; },
/* harmony export */   "wx": function() { return /* binding */ validationReqSchema; }
/* harmony export */ });
/* unused harmony export requestSchema */
/* harmony import */ var _swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(14924);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(69396);



var formTypes = {
    SELECTION: "SELECTION_FORM",
    EMAIL: "EMAIL_FORM",
    PHONE: "PHONE_FORM",
    SEND_OTP_METHOD: "SEND_OTP_METHOD",
    CHECK_PHONE: "CHECK_PHONE_FORM",
    NOTIFY_VERIFICATION_PHONE: "NOTIFY_VERIFICATION_PHONE",
    NOTIFY_VERIFICATION_EMAIL: "NOTIFY_VERIFICATION_EMAIL",
    VERIFY_EMAIL: "VERIFY_EMAIL_FORM",
    VERIFY_PHONE: "VERIFY_PHONE_FORM",
    PROFILE_PHOTO: "PROFILE_PHOTO_FORM",
    CONNECT_FB: "CONNECT_FB_FORM",
    DISCOVER_PEOPLE: "DISCOVER_PEOPLE_FORM",
    DISCOVER_STOCK: "DISCOVER_STOCK_FORM",
    LOADING: "LOADING_FORM",
    SUCCESS: "SUCCESSFUL_REGISTRATION",
    PHONE_ERROR: "PHONE_ERROR_FORM",
    OTP_LIMIT: "OTP_LIMIT"
};
var registerTypes = {
    EMAIL: "email",
    GOOGLE: "google",
    FACEBOOK: "facebook"
};
var newRegisterTypes = {
    EMAIL: "IDENTITY_TYPE_EMAIL",
    GOOGLE: "IDENTITY_TYPE_GOOGLE",
    FACEBOOK: "IDENTITY_TYPE_FACEBOOK"
};
var emailVerifyStatus = {
    SIGNIN: "STATE_CHECK_EMAIL_SIGNIN",
    REGISTER: "STATE_CHECK_EMAIL_SIGNIN"
};
var phoneVerifyStatus = {
    FAIL: "VERIFY_STATUS_FAIL",
    SUCCESS: "VERIFY_STATUS_SUCCESS"
};
var _obj;
var mappingNewRegisterTypes = (_obj = {}, (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(_obj, registerTypes.EMAIL, newRegisterTypes.EMAIL), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(_obj, registerTypes.GOOGLE, newRegisterTypes.GOOGLE), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(_obj, registerTypes.FACEBOOK, newRegisterTypes.FACEBOOK), _obj);
var requestSchema = {
    data: null,
    isLoading: false,
    message: "",
    error: ""
};
var validationReqSchema = (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({}, requestSchema), {
    isChecked: false
});
var hints = {
    NAME: {
        title: "What's Your Name",
        description: "Using your real name makes it easier for you to be recognised and build a network."
    },
    EMAIL: {
        title: "What's Your Email",
        description: "You will need your email to login and reset your password in the future."
    },
    USERNAME: {
        title: "Pick a Username",
        description: "Your username is your brand. Pick one that is professional and credible. You cannot change it later."
    },
    PASSWORD: {
        title: "Create a Password",
        description: "Your password needs to be at least 6 or more characters long. Pick a password that you can remember."
    }
};
var errorMessage = {
    EMAIL_REGISTERED: "Email ini sudah pernah terdaftar di Stockbit. Silahkan coba login.",
    PHONE_REGISTERED: "Nomor telepon ini sudah pernah terdaftar di Stockbit. Silahkan coba login.",
    FAIL_TO_VERIFY_PHONE: "Gagal verifikasi nomor telepon. Silahkan coba lagi.",
    FAIL_TO_VERIFY_EMAIL: "Gagal verifikasi email. Silahkan coba lagi.",
    SOCIAL_ACCOUNT_REGISTERED: "Akun social sudah terdaftar, silakan gunakan akun social lain",
    SOCIAL_EMAIL_REGISTERED: "Email Sudah Terdaftar"
};
var emailStatuses = {
    VERIFIED: "verified",
    NOT_VERIFIED: "not_verified"
};
var LS_EMAIL_REGISTER = "emailRegister";
var LS_PHONE_REGISTER = "phoneRegister";



/***/ }),

/***/ 7952:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Sz": function() { return /* binding */ effects; },
/* harmony export */   "wl": function() { return /* binding */ selectors; }
/* harmony export */ });
/* unused harmony export rootSlice */
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(69396);
/* harmony import */ var _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34051);
/* harmony import */ var _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(61876);
/* harmony import */ var _reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(68697);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var lib_api_auth__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(6242);
/* harmony import */ var lib_entities_credentials__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(21671);
/* harmony import */ var global_AlertErrorMessage__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(25516);
/* harmony import */ var utils_clevertap__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(48028);
/* harmony import */ var lib_api_authNext__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(39762);
/* harmony import */ var constants_errorMessage__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(61608);
/* harmony import */ var constants_successMessage__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(41208);
/* harmony import */ var utils_logger__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(91635);
/* harmony import */ var _utils__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(7865);
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(28456);
/* harmony import */ var _types__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(72228);
/* eslint-disable no-use-before-define */ 





// API





// Constants






// Actions
var CONTEXT = "@register";
var actionType = {
    SUBMIT: "".concat(CONTEXT, "/submit"),
    RESEND: "".concat(CONTEXT, "/resend"),
    VERIFY: "".concat(CONTEXT, "/verify"),
    VERIFY_REGISTRATION: "".concat(CONTEXT, "/verify_registration"),
    VERIFY_EMAIL_OTP: "".concat(CONTEXT, "/verify_email_otp"),
    RESEND_EMAIL_OTP: "".concat(CONTEXT, "/resend_email_otp"),
    VERIFY_PHONE: "".concat(CONTEXT, "/verify_phone"),
    VERIFY_PHONE_OTP: "".concat(CONTEXT, "/verify_phone_otp"),
    RESEND_PHONE_OTP: "".concat(CONTEXT, "/resend_phone_otp")
};
// Initial state
var initialState = {
    currentForm: _constants__WEBPACK_IMPORTED_MODULE_11__/* .formTypes.SELECTION */ .o_.SELECTION,
    type: _constants__WEBPACK_IMPORTED_MODULE_11__/* .registerTypes.EMAIL */ .E8.EMAIL,
    accountid: "",
    accountkey: "",
    fullname: "",
    email: "",
    username: "",
    password: "",
    passwordConf: "",
    phoneNumber: "",
    channel: null,
    code: "62",
    country: "",
    exchange: "",
    supportId: "",
    captchaToken: "",
    captchaVersion: 3,
    tempKey: "",
    emailStatus: ""
};
// Reducers (define how the state changes)
var reducers = {
    changeForm: function(state, action) {
        state.currentForm = action.payload.target;
    },
    storeProfile: function(state, action) {
        var _payload = action.payload, nextForm = _payload.nextForm, fullname = _payload.fullname, email = _payload.email, username = _payload.username, password = _payload.password, passwordConf = _payload.passwordConf, tempKey = _payload.tempKey, emailStatus = _payload.emailStatus;
        state.currentForm = nextForm;
        state.fullname = fullname;
        state.email = email;
        state.username = username;
        state.password = password;
        state.passwordConf = passwordConf;
        state.tempKey = tempKey;
        state.emailStatus = emailStatus;
    },
    storeSocialIdentities: function(state, action) {
        var _payload = action.payload, type = _payload.type, accountid = _payload.accountid, accountkey = _payload.accountkey, fullname = _payload.fullname, email = _payload.email, username = _payload.username, error = _payload.error;
        state.type = type;
        state.accountid = accountid;
        state.accountkey = accountkey;
        state.fullname = fullname;
        state.email = email;
        state.username = username;
        state.error = error;
    },
    storePhoneNumber: function(state, action) {
        var _payload = action.payload, phoneNumber = _payload.phoneNumber, country = _payload.country;
        state.currentForm = _constants__WEBPACK_IMPORTED_MODULE_11__/* .formTypes.NOTIFY_VERIFICATION_PHONE */ .o_.NOTIFY_VERIFICATION_PHONE;
        state.phoneNumber = phoneNumber;
        state.country = country.iso2;
    },
    storeCaptchaToken: function(state, action) {
        state.captchaToken = action.payload.token;
    },
    storeEmailVerifData: function(state, action) {
        state.tempKey = action.payload.tempKey;
        state.emailStatus = action.payload.emailStatus;
    },
    storeAllData: function(state, action) {
        return action.payload;
    },
    savePhoneNumber: function(state, action) {
        var _payload = action.payload, phoneNumber = _payload.phoneNumber, code = _payload.code;
        state.currentForm = _constants__WEBPACK_IMPORTED_MODULE_11__/* .formTypes.SEND_OTP_METHOD */ .o_.SEND_OTP_METHOD;
        state.phoneNumber = phoneNumber;
        state.code = code;
        (0,_utils__WEBPACK_IMPORTED_MODULE_10__/* .storeData */ .xG)((0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z)({}, state), {
            currentForm: _constants__WEBPACK_IMPORTED_MODULE_11__/* .formTypes.PHONE */ .o_.PHONE
        }));
    },
    resetAllData: function() {
        return initialState;
    }
};
// Effects (thunks / async operations that needs side effects)
var effects = {
    // verify registration
    verifyRegistration: (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_15__/* .createAsyncThunk */ .hg)(actionType.VERIFY_REGISTRATION, function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z)(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(param, param1) {
            var fullname, email, username, password, verificationToken, getState, rejectWithValue, ref, _register, _root, prevTempKey, type, emailStatus, response, _data, message, _data1, tempKey, status, nextForm, ref1, message1;
            return _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        fullname = param.fullname, email = param.email, username = param.username, password = param.password, verificationToken = param.verificationToken, getState = param1.getState, rejectWithValue = param1.rejectWithValue;
                        _ctx.prev = 1;
                        ref = getState(), _register = ref.register, _root = _register.root, prevTempKey = _root.tempKey, type = _root.type, emailStatus = _root.emailStatus;
                        ;
                        if (!(type === _constants__WEBPACK_IMPORTED_MODULE_11__/* .registerTypes.FACEBOOK */ .E8.FACEBOOK)) {
                            _ctx.next = 10;
                            break;
                        }
                        _ctx.next = 7;
                        return lib_api_auth__WEBPACK_IMPORTED_MODULE_2__/* ["default"].verifyEmailRegistration */ .Z.verifyEmailRegistration(prevTempKey, email, _constants__WEBPACK_IMPORTED_MODULE_11__/* .newRegisterTypes.FACEBOOK */ .AY.FACEBOOK);
                    case 7:
                        response = _ctx.sent;
                        _ctx.next = 13;
                        break;
                    case 10:
                        _ctx.next = 12;
                        return lib_api_auth__WEBPACK_IMPORTED_MODULE_2__/* ["default"].verifyRegistration */ .Z.verifyRegistration({
                            fullname: fullname,
                            email: email,
                            username: username,
                            password: password,
                            verificationToken: verificationToken
                        });
                    case 12:
                        response = _ctx.sent;
                    case 13:
                        _data = response.data, message = _data.message, _data1 = _data.data, tempKey = _data1.key, status = _data1.status;
                        nextForm = _constants__WEBPACK_IMPORTED_MODULE_11__/* .formTypes.VERIFY_EMAIL */ .o_.VERIFY_EMAIL;
                        if (status === "verified") {
                            nextForm = _constants__WEBPACK_IMPORTED_MODULE_11__/* .formTypes.PHONE */ .o_.PHONE;
                        } else {
                            (0,global_AlertErrorMessage__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(message, constants_successMessage__WEBPACK_IMPORTED_MODULE_8__/* ["default"].ALERT_GREEN */ .Z.ALERT_GREEN);
                        }
                        return _ctx.abrupt("return", {
                            message: message,
                            tempKey: tempKey,
                            nextForm: nextForm,
                            type: type,
                            emailStatus: emailStatus
                        });
                    case 19:
                        _ctx.prev = 19;
                        _ctx.t0 = _ctx["catch"](1);
                        ;
                        message1 = _ctx.t0 === null || _ctx.t0 === void 0 ? void 0 : (ref1 = _ctx.t0.cause) === null || ref1 === void 0 ? void 0 : ref1.message;
                        (0,global_AlertErrorMessage__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(message1, constants_errorMessage__WEBPACK_IMPORTED_MODULE_7__/* ["default"].ALERT_RED */ .Z.ALERT_RED);
                        return _ctx.abrupt("return", rejectWithValue(message1));
                    case 25:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    1,
                    19
                ]
            ]);
        }));
        return function(_, _1) {
            return _ref.apply(this, arguments);
        };
    }()),
    // verify email otp
    validateEmailOtp: (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_15__/* .createAsyncThunk */ .hg)(actionType.VERIFY_EMAIL_OTP, function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z)(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(param, param1) {
            var code, getState, dispatch, ref, root, tempKey, response, _data, error_type, message, _data1, valid, emailStatus, ref1, message1;
            return _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        code = param.code, getState = param1.getState, dispatch = param1.dispatch;
                        ref = getState(), root = ref.register.root;
                        _ctx.prev = 2;
                        tempKey = root.tempKey;
                        _ctx.next = 6;
                        return lib_api_auth__WEBPACK_IMPORTED_MODULE_2__/* ["default"].validateEmailOtp */ .Z.validateEmailOtp(tempKey, code);
                    case 6:
                        response = _ctx.sent;
                        if (!(response && !response.data)) {
                            _ctx.next = 9;
                            break;
                        }
                        throw new Error("Could not fetch data");
                    case 9:
                        _data = response.data, error_type = _data.error_type, message = _data.message, _data1 = _data.data, valid = _data1.valid, emailStatus = _data1.state;
                        if (!(emailStatus === _constants__WEBPACK_IMPORTED_MODULE_11__/* .emailVerifyStatus.SIGNIN */ .HH.SIGNIN)) {
                            _ctx.next = 12;
                            break;
                        }
                        throw new Error(_constants__WEBPACK_IMPORTED_MODULE_11__/* .errorMessage.EMAIL_REGISTERED */ .N3.EMAIL_REGISTERED);
                    case 12:
                        if (!(error_type || !valid)) {
                            _ctx.next = 14;
                            break;
                        }
                        throw new Error(message);
                    case 14:
                        return _ctx.abrupt("return", {
                            message: response.data.message,
                            root: root
                        });
                    case 17:
                        _ctx.prev = 17;
                        _ctx.t0 = _ctx["catch"](2);
                        ;
                        message1 = _ctx.t0 === null || _ctx.t0 === void 0 ? void 0 : (ref1 = _ctx.t0.cause) === null || ref1 === void 0 ? void 0 : ref1.message;
                        if (!(message1 === _constants__WEBPACK_IMPORTED_MODULE_11__/* .errorMessage.EMAIL_REGISTERED */ .N3.EMAIL_REGISTERED)) {
                            _ctx.next = 28;
                            break;
                        }
                        (0,global_AlertErrorMessage__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_constants__WEBPACK_IMPORTED_MODULE_11__/* .errorMessage.EMAIL_REGISTERED */ .N3.EMAIL_REGISTERED, constants_errorMessage__WEBPACK_IMPORTED_MODULE_7__/* ["default"].ALERT_RED */ .Z.ALERT_RED);
                        localStorage.setItem(_constants__WEBPACK_IMPORTED_MODULE_11__/* .LS_EMAIL_REGISTER */ .hb, root.email);
                        next_router__WEBPACK_IMPORTED_MODULE_1___default().push("/login");
                        // remove previous data from register form
                        dispatch(rootSlice.actions.resetAllData());
                        (0,_utils__WEBPACK_IMPORTED_MODULE_10__/* .removeData */ .NU)();
                        return _ctx.abrupt("return", Promise.reject(message1));
                    case 28:
                        (0,global_AlertErrorMessage__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(message1, constants_errorMessage__WEBPACK_IMPORTED_MODULE_7__/* ["default"].ALERT_RED */ .Z.ALERT_RED);
                        return _ctx.abrupt("return", Promise.reject(message1));
                    case 30:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    2,
                    17
                ]
            ]);
        }));
        return function(_, _1) {
            return _ref.apply(this, arguments);
        };
    }()),
    // resend email otp
    resendEmailOtp: (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_15__/* .createAsyncThunk */ .hg)(actionType.RESEND_EMAIL_OTP, function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z)(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(_, param) {
            var getState, ref, _register, _root, tempKey, email, type, response, message, ref1, message1;
            return _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        getState = param.getState;
                        _ctx.prev = 1;
                        ref = getState(), _register = ref.register, _root = _register.root, tempKey = _root.tempKey, email = _root.email, type = _root.type;
                        _ctx.next = 5;
                        return lib_api_auth__WEBPACK_IMPORTED_MODULE_2__/* ["default"].verifyEmailRegistration */ .Z.verifyEmailRegistration(tempKey, email, _constants__WEBPACK_IMPORTED_MODULE_11__/* .mappingNewRegisterTypes */ .Io[type]);
                    case 5:
                        response = _ctx.sent;
                        message = response.data.message;
                        (0,global_AlertErrorMessage__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(message, constants_successMessage__WEBPACK_IMPORTED_MODULE_8__/* ["default"].ALERT_GREEN */ .Z.ALERT_GREEN);
                        return _ctx.abrupt("return", {
                            message: message
                        });
                    case 11:
                        _ctx.prev = 11;
                        _ctx.t0 = _ctx["catch"](1);
                        ;
                        message1 = _ctx.t0 === null || _ctx.t0 === void 0 ? void 0 : (ref1 = _ctx.t0.cause) === null || ref1 === void 0 ? void 0 : ref1.message;
                        (0,global_AlertErrorMessage__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(message1, constants_errorMessage__WEBPACK_IMPORTED_MODULE_7__/* ["default"].ALERT_RED */ .Z.ALERT_RED);
                        return _ctx.abrupt("return", Promise.reject(message1));
                    case 17:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    1,
                    11
                ]
            ]);
        }));
        return function(_, _1) {
            return _ref.apply(this, arguments);
        };
    }()),
    // verify phone
    verifyPhone: (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_15__/* .createAsyncThunk */ .hg)(actionType.VERIFY_PHONE, function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z)(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(param, param1) {
            var phoneNumber, code, channel, getState, dispatch, ref, root, prevTempKey, response, _data, error_type, message, _data1, tempKey, ref1, ref2, errorType, message1;
            return _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        phoneNumber = param.phoneNumber, code = param.code, channel = param.channel, getState = param1.getState, dispatch = param1.dispatch;
                        _ctx.prev = 1;
                        if (!(!phoneNumber || !code)) {
                            _ctx.next = 4;
                            break;
                        }
                        throw new Error("Phone number is required!");
                    case 4:
                        ref = getState(), root = ref.register.root;
                        prevTempKey = root.tempKey;
                        _ctx.next = 8;
                        return lib_api_auth__WEBPACK_IMPORTED_MODULE_2__/* ["default"].verifyPhoneRegistration */ .Z.verifyPhoneRegistration(prevTempKey || undefined, code, phoneNumber.slice(code.length), channel);
                    case 8:
                        response = _ctx.sent;
                        if (!(response && !response.data)) {
                            _ctx.next = 11;
                            break;
                        }
                        throw new Error("Could not fetch data");
                    case 11:
                        _data = response.data, error_type = _data.error_type, message = _data.message, _data1 = _data.data, tempKey = _data1.key;
                        if (!error_type) {
                            _ctx.next = 14;
                            break;
                        }
                        throw new Error(message);
                    case 14:
                        (0,global_AlertErrorMessage__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(message, constants_successMessage__WEBPACK_IMPORTED_MODULE_8__/* ["default"].ALERT_GREEN */ .Z.ALERT_GREEN);
                        return _ctx.abrupt("return", {
                            message: message,
                            tempKey: tempKey,
                            phoneNumber: phoneNumber,
                            code: code,
                            channel: channel,
                            root: root
                        });
                    case 18:
                        _ctx.prev = 18;
                        _ctx.t0 = _ctx["catch"](1);
                        ;
                        errorType = _ctx.t0 === null || _ctx.t0 === void 0 ? void 0 : (ref1 = _ctx.t0.cause) === null || ref1 === void 0 ? void 0 : ref1.errorType;
                        message1 = _ctx.t0 === null || _ctx.t0 === void 0 ? void 0 : (ref2 = _ctx.t0.cause) === null || ref2 === void 0 ? void 0 : ref2.message;
                        if (errorType === _types__WEBPACK_IMPORTED_MODULE_12__/* .VerifyPhoneErrorType.OtpLimit */ .x.OtpLimit) {
                            dispatch(rootSlice.actions.changeForm({
                                target: _constants__WEBPACK_IMPORTED_MODULE_11__/* .formTypes.OTP_LIMIT */ .o_.OTP_LIMIT
                            }));
                        } else {
                            dispatch(rootSlice.actions.changeForm({
                                target: _constants__WEBPACK_IMPORTED_MODULE_11__/* .formTypes.PHONE */ .o_.PHONE
                            }));
                            (0,global_AlertErrorMessage__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(message1, constants_errorMessage__WEBPACK_IMPORTED_MODULE_7__/* ["default"].ALERT_RED */ .Z.ALERT_RED);
                        }
                        return _ctx.abrupt("return", Promise.reject(message1));
                    case 25:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    1,
                    18
                ]
            ]);
        }));
        return function(_, _1) {
            return _ref.apply(this, arguments);
        };
    }()),
    // validate phone otp
    validatePhoneOtp: (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_15__/* .createAsyncThunk */ .hg)(actionType.VERIFY_PHONE_OTP, function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z)(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(param, param1) {
            var otp, getState, dispatch, ref, _register, _root, tempKey, type, response, status, _data, _user, username, email, avatar, id, message;
            return _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        otp = param.otp, getState = param1.getState, dispatch = param1.dispatch;
                        _ctx.prev = 1;
                        ref = getState(), _register = ref.register, _root = _register.root, tempKey = _root.tempKey, type = _root.type;
                        _ctx.next = 5;
                        return (0,lib_api_authNext__WEBPACK_IMPORTED_MODULE_6__/* .verifyOTP */ .qD)({
                            key: tempKey,
                            otp: otp
                        });
                    case 5:
                        response = _ctx.sent;
                        if (!response.data.error_type) {
                            _ctx.next = 8;
                            break;
                        }
                        throw new Error(response.data.message);
                    case 8:
                        status = response.data.data.status;
                        if (!(status === _constants__WEBPACK_IMPORTED_MODULE_11__/* .phoneVerifyStatus.FAIL */ .w7.FAIL)) {
                            _ctx.next = 12;
                            break;
                        }
                        dispatch(rootSlice.actions.changeForm({
                            target: _constants__WEBPACK_IMPORTED_MODULE_11__/* .formTypes.PHONE_ERROR */ .o_.PHONE_ERROR
                        }));
                        throw new Error(_constants__WEBPACK_IMPORTED_MODULE_11__/* .errorMessage.PHONE_REGISTERED */ .N3.PHONE_REGISTERED);
                    case 12:
                        if (!(status !== _constants__WEBPACK_IMPORTED_MODULE_11__/* .phoneVerifyStatus.SUCCESS */ .w7.SUCCESS)) {
                            _ctx.next = 14;
                            break;
                        }
                        throw new Error(_constants__WEBPACK_IMPORTED_MODULE_11__/* .errorMessage.FAIL_TO_VERIFY_PHONE */ .N3.FAIL_TO_VERIFY_PHONE);
                    case 14:
                        (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_5__/* .clevertapEvent */ .Lq)("Register Successful", {
                            "Register Method": type
                        });
                        _data = response.data.data, _user = _data.user, username = _user.username, email = _user.email, avatar = _user.avatar, id = _user.id;
                        (0,_utils__WEBPACK_IMPORTED_MODULE_10__/* .onUpdateAvatarIds */ .px)(id);
                        (0,_utils__WEBPACK_IMPORTED_MODULE_10__/* .removeData */ .NU)();
                        // create clevertap's user profile after success registration
                        // Track if username is empty
                        if (!username) {
                            (0,utils_logger__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .ZP)(new Error("[CT initialization Error]: username is empty"), {
                                place: "src/features/register/slice.ts",
                                event: "validatePhoneOtp",
                                eventParam: {
                                    profile: response.data.data
                                }
                            });
                        }
                        // @ts-ignore
                        (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_5__/* .clevertapProfilingUser */ .$b)({
                            isInitProfile: true,
                            identity: username,
                            email: email,
                            profilePictureUrl: avatar
                        });
                        // save userdata to credentials entities
                        dispatch(lib_entities_credentials__WEBPACK_IMPORTED_MODULE_3__/* ["default"].actions.loadCredentialsExodus */ .ZP.actions.loadCredentialsExodus(response.data.data));
                        if (type === _constants__WEBPACK_IMPORTED_MODULE_11__/* .registerTypes.GOOGLE */ .E8.GOOGLE || type === _constants__WEBPACK_IMPORTED_MODULE_11__/* .registerTypes.FACEBOOK */ .E8.FACEBOOK) {
                            dispatch(rootSlice.actions.changeForm({
                                target: _constants__WEBPACK_IMPORTED_MODULE_11__/* .formTypes.SUCCESS */ .o_.SUCCESS
                            }));
                        } else {
                            (0,global_AlertErrorMessage__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(response.data.message, constants_successMessage__WEBPACK_IMPORTED_MODULE_8__/* ["default"].ALERT_GREEN */ .Z.ALERT_GREEN);
                        }
                        return _ctx.abrupt("return", {
                            message: response.data.message
                        });
                    case 25:
                        _ctx.prev = 25;
                        _ctx.t0 = _ctx["catch"](1);
                        message = (0,_utils__WEBPACK_IMPORTED_MODULE_10__/* .formatErrorMessage */ .jN)(_ctx.t0);
                        if (!(message === _constants__WEBPACK_IMPORTED_MODULE_11__/* .errorMessage.PHONE_REGISTERED */ .N3.PHONE_REGISTERED)) {
                            _ctx.next = 30;
                            break;
                        }
                        return _ctx.abrupt("return", Promise.reject(message));
                    case 30:
                        (0,global_AlertErrorMessage__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(message, constants_errorMessage__WEBPACK_IMPORTED_MODULE_7__/* ["default"].ALERT_RED */ .Z.ALERT_RED);
                        return _ctx.abrupt("return", Promise.reject(message));
                    case 32:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    1,
                    25
                ]
            ]);
        }));
        return function(_, _1) {
            return _ref.apply(this, arguments);
        };
    }()),
    // resend phone otp
    resendPhoneOtp: (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_15__/* .createAsyncThunk */ .hg)(actionType.RESEND_PHONE_OTP, function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z)(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(_, param) {
            var getState, ref, _register, _root, tempKey, phoneNumber, code, channel, response, _data, error_type, message, ref1, message1;
            return _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        getState = param.getState;
                        _ctx.prev = 1;
                        ref = getState(), _register = ref.register, _root = _register.root, tempKey = _root.tempKey, phoneNumber = _root.phoneNumber, code = _root.code, channel = _root.channel;
                        _ctx.next = 5;
                        return lib_api_auth__WEBPACK_IMPORTED_MODULE_2__/* ["default"].verifyPhoneRegistration */ .Z.verifyPhoneRegistration(tempKey, String(code), phoneNumber.slice(String(code).length), channel);
                    case 5:
                        response = _ctx.sent;
                        if (!(response && !response.data)) {
                            _ctx.next = 8;
                            break;
                        }
                        throw new Error("Could not fetch data");
                    case 8:
                        _data = response.data, error_type = _data.error_type, message = _data.message;
                        if (!error_type) {
                            _ctx.next = 11;
                            break;
                        }
                        throw new Error(message);
                    case 11:
                        (0,global_AlertErrorMessage__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(message, constants_successMessage__WEBPACK_IMPORTED_MODULE_8__/* ["default"].ALERT_GREEN */ .Z.ALERT_GREEN);
                        return _ctx.abrupt("return", {
                            message: message
                        });
                    case 15:
                        _ctx.prev = 15;
                        _ctx.t0 = _ctx["catch"](1);
                        ;
                        message1 = _ctx.t0 === null || _ctx.t0 === void 0 ? void 0 : (ref1 = _ctx.t0.cause) === null || ref1 === void 0 ? void 0 : ref1.message;
                        (0,global_AlertErrorMessage__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(message1, constants_errorMessage__WEBPACK_IMPORTED_MODULE_7__/* ["default"].ALERT_RED */ .Z.ALERT_RED);
                        return _ctx.abrupt("return", Promise.reject(message1));
                    case 21:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    1,
                    15
                ]
            ]);
        }));
        return function(_, _1) {
            return _ref.apply(this, arguments);
        };
    }())
};
// Selectors (getters)
var selectors = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_17__/* .createSelector */ .P1)(function(state) {
    return state.register.root;
}, function(root) {
    return root;
});
// Extra reducers (handle actions that are not defined in this slice)
var extraReducers = function(builder) {
    builder.addCase(effects.verifyRegistration.pending, function(state) {
        state.isLoading = true;
        state.error = null;
    }).addCase(effects.verifyRegistration.fulfilled, function(state, action) {
        var _arg = action.meta.arg, fullname = _arg.fullname, email = _arg.email, username = _arg.username, password = _arg.password, passwordConf = _arg.passwordConf;
        state.isLoading = false;
        state.fullname = fullname;
        state.email = email;
        state.username = username;
        state.password = password;
        state.passwordConf = passwordConf;
        state.tempKey = action.payload.tempKey;
        state.currentForm = action.payload.nextForm;
        state.type = action.payload.type;
        state.emailStatus = action.payload.emailStatus;
        (0,_utils__WEBPACK_IMPORTED_MODULE_10__/* .storeData */ .xG)((0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z)({}, action.payload.root), {
            isLoading: false,
            fullname: fullname,
            email: email,
            username: username,
            password: password,
            passwordConf: passwordConf,
            tempKey: action.payload.tempKey,
            type: action.payload.type,
            emailStatus: action.payload.emailStatus,
            currentForm: action.payload.nextForm
        }));
    }).addCase(effects.verifyRegistration.rejected, function(state, action) {
        state.isLoading = false;
        state.error = action.error;
    }).addCase(effects.validateEmailOtp.pending, function(state) {
        state.isLoading = true;
        state.error = null;
    }).addCase(effects.validateEmailOtp.fulfilled, function(state, action) {
        state.currentForm = _constants__WEBPACK_IMPORTED_MODULE_11__/* .formTypes.PHONE */ .o_.PHONE;
        state.isLoading = false;
        (0,_utils__WEBPACK_IMPORTED_MODULE_10__/* .storeData */ .xG)((0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z)({}, action.payload.root), {
            isLoading: false,
            currentForm: _constants__WEBPACK_IMPORTED_MODULE_11__/* .formTypes.PHONE */ .o_.PHONE
        }));
    }).addCase(effects.validateEmailOtp.rejected, function(state, action) {
        state.isLoading = false;
        state.error = action.error;
    }).addCase(effects.verifyPhone.pending, function(state) {
        state.isLoading = true;
        state.error = null;
    }).addCase(effects.verifyPhone.fulfilled, function(state, action) {
        state.isLoading = false;
        state.tempKey = action.payload.tempKey;
        state.phoneNumber = action.payload.phoneNumber;
        state.code = action.payload.code;
        state.channel = action.payload.channel;
        state.currentForm = _constants__WEBPACK_IMPORTED_MODULE_11__/* .formTypes.VERIFY_PHONE */ .o_.VERIFY_PHONE;
        (0,_utils__WEBPACK_IMPORTED_MODULE_10__/* .storeData */ .xG)((0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z)({}, action.payload.root), {
            isLoading: false,
            phoneNumber: action.payload.phoneNumber,
            code: action.payload.code,
            tempKey: action.payload.tempKey,
            currentForm: _constants__WEBPACK_IMPORTED_MODULE_11__/* .formTypes.VERIFY_PHONE */ .o_.VERIFY_PHONE
        }));
    }).addCase(effects.verifyPhone.rejected, function(state, action) {
        state.isLoading = false;
        state.error = action.error;
    });
};
var rootSlice = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_15__/* .createSlice */ .oM)({
    name: "register",
    initialState: initialState,
    reducers: reducers,
    extraReducers: extraReducers
});
/* harmony default export */ __webpack_exports__["ZP"] = (rootSlice);


/***/ }),

/***/ 72228:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "x": function() { return /* binding */ VerifyPhoneErrorType; }
/* harmony export */ });
var VerifyPhoneErrorType;
(function(VerifyPhoneErrorType) {
    VerifyPhoneErrorType["OtpLimit"] = "OTP_LIMIT";
})(VerifyPhoneErrorType || (VerifyPhoneErrorType = {}));


/***/ }),

/***/ 7865:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Kq": function() { return /* binding */ validatePasswordConf; },
/* harmony export */   "NU": function() { return /* binding */ removeData; },
/* harmony export */   "jN": function() { return /* binding */ formatErrorMessage; },
/* harmony export */   "oH": function() { return /* binding */ validateEmail; },
/* harmony export */   "px": function() { return /* binding */ onUpdateAvatarIds; },
/* harmony export */   "xG": function() { return /* binding */ storeData; },
/* harmony export */   "zj": function() { return /* binding */ handleRegistrationError; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(69396);
/* harmony import */ var moment__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(30381);
/* harmony import */ var moment__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(moment__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var constants_app__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(86123);
/* harmony import */ var constants_errorMessage__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(61608);
/* harmony import */ var constants_localstorage__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(44252);
/* harmony import */ var global_AlertErrorMessage__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(25516);
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(28456);









var storeData = function(data) {
    if (data && (0,constants_app__WEBPACK_IMPORTED_MODULE_2__/* .isClient */ .C5)()) {
        var newData = (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({}, data), {
            storedAt: moment__WEBPACK_IMPORTED_MODULE_0___default()()
        });
        localStorage.setItem(constants_localstorage__WEBPACK_IMPORTED_MODULE_8__/* .REGISTRATION_DATA */ .BP, JSON.stringify(newData));
    }
};
var removeData = function() {
    if ((0,constants_app__WEBPACK_IMPORTED_MODULE_2__/* .isClient */ .C5)()) {
        var data = localStorage.getItem(constants_localstorage__WEBPACK_IMPORTED_MODULE_8__/* .REGISTRATION_DATA */ .BP);
        if (data) {
            localStorage.removeItem(constants_localstorage__WEBPACK_IMPORTED_MODULE_8__/* .REGISTRATION_DATA */ .BP);
        }
    }
};
var onUpdateAvatarIds = function(userId) {
    var ref;
    var avatarUserIds = ((ref = localStorage.getItem("avatarUserIds")) === null || ref === void 0 ? void 0 : ref.split(",")) || [];
    if (!avatarUserIds.includes(userId)) {
        avatarUserIds.push(userId);
    }
    localStorage.setItem("avatarUserIds", avatarUserIds.join(","));
};
var formatErrorMessage = function(error) {
    var message;
    if (typeof error === "string") {
        message = error;
    } else {
        var ref, ref1;
        message = (error === null || error === void 0 ? void 0 : (ref = error.response) === null || ref === void 0 ? void 0 : (ref1 = ref.data) === null || ref1 === void 0 ? void 0 : ref1.message) || (error === null || error === void 0 ? void 0 : error.message) || "";
    }
    message = message.replace(/;/g, ""); // Replace all occurrences of ';' with ''
    message = message.replace(" |error_type=1", "");
    return message;
};
var validateEmail = function(value) {
    // eslint-disable-next-line no-useless-escape
    if (!value.match(/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,10})+$/)) {
        return {
            error: "Email format is not valid!",
            field: "email"
        };
    }
    return {
        message: "Email format is valid",
        field: "email"
    };
};
var validatePasswordConf = function(password, passwordConf) {
    if (password !== passwordConf) {
        return "Password dan Confirm Password tidak cocok";
    }
    return null;
};
var handleRegistrationError = function(responseMessage, email) {
    if (responseMessage === _constants__WEBPACK_IMPORTED_MODULE_5__/* .errorMessage.SOCIAL_ACCOUNT_REGISTERED */ .N3.SOCIAL_ACCOUNT_REGISTERED || responseMessage === _constants__WEBPACK_IMPORTED_MODULE_5__/* .errorMessage.SOCIAL_EMAIL_REGISTERED */ .N3.SOCIAL_EMAIL_REGISTERED) {
        localStorage.setItem(_constants__WEBPACK_IMPORTED_MODULE_5__/* .LS_EMAIL_REGISTER */ .hb, email);
        next_router__WEBPACK_IMPORTED_MODULE_1___default().push("/login");
        (0,global_AlertErrorMessage__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_constants__WEBPACK_IMPORTED_MODULE_5__/* .errorMessage.EMAIL_REGISTERED */ .N3.EMAIL_REGISTERED, constants_errorMessage__WEBPACK_IMPORTED_MODULE_3__/* ["default"].ALERT_RED */ .Z.ALERT_RED);
        return;
    }
    (0,global_AlertErrorMessage__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(responseMessage, constants_errorMessage__WEBPACK_IMPORTED_MODULE_3__/* ["default"].ALERT_RED */ .Z.ALERT_RED);
};


/***/ }),

/***/ 29658:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

var If = function(param) {
    var children = param.children, condition = param.condition;
    if (!condition) {
        return null;
    }
    // render children if the condition is truthy
    return children;
};
/* harmony default export */ __webpack_exports__["Z"] = (If); /**
 * https://www.stefanjudis.com/snippets/a-react-if-component/
 *
 * Use the component as follows:
 *
 * <IF condition={condition}>
 *   <Greeter username={user.name} />
 * </IF>
 */ 


/***/ }),

/***/ 6242:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(14924);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(26042);
/* harmony import */ var config_requestExodus__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(68425);
/* harmony import */ var _instances_exodus__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(78372);
/** @typedef {import('../../../@types/api-response').APIResponse} APIResponse */ 



var requestExodus = (0,config_requestExodus__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)();
var requestExodusNoError = (0,config_requestExodus__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(false);
var authRequestExodus = function(headersFromNextjsAPI) {
    var otherCustomHeader = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : null;
    return (0,config_requestExodus__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(false, undefined, true, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({
        "x-real-user-agent": (headersFromNextjsAPI === null || headersFromNextjsAPI === void 0 ? void 0 : headersFromNextjsAPI["x-real-user-agent"]) || "-",
        "x-real-user-ip": (headersFromNextjsAPI === null || headersFromNextjsAPI === void 0 ? void 0 : headersFromNextjsAPI["x-real-user-ip"]) || "-",
        "x-forwarded-for": (headersFromNextjsAPI === null || headersFromNextjsAPI === void 0 ? void 0 : headersFromNextjsAPI["x-forwarded-for"]) || "-"
    }, otherCustomHeader));
};
/**
 * Email Login
 * @param {string} user - email / username
 * @param {string} password - password
 * @param {string} verificationToken - password
 */ var emailLogin = function(param, headersFromNextjsAPI) {
    var user = param.user, password = param.password, verificationToken = param.verificationToken;
    return authRequestExodus(headersFromNextjsAPI).post("/login/v2/browser", {
        user: user,
        password: password,
        verification_token: verificationToken
    });
};
/**
 * Facebook Login
 * @param {string} id - facebook user id
 * @param {string} idToken - facebook access token
 */ var fbLogin = function(param, headersFromNextjsAPI) {
    var id = param.id, idToken = param.idToken;
    return authRequestExodus(headersFromNextjsAPI).post("/login/facebook", {
        fb_access_token: idToken,
        fb_user_id: id
    });
};
/**
 * Google Login
 * @param {string} id - google account id
 * @param {string} idToken - google access token
 */ var googleLogin = function(param, headersFromNextjsAPI) {
    var id = param.id, idToken = param.idToken;
    return authRequestExodus(headersFromNextjsAPI).post("/login/google", {
        google_user_id: id,
        google_id_token: idToken
    });
};
var logout = function(param, headersFromNextjsAPI) {
    var token = param.token;
    return authRequestExodus(headersFromNextjsAPI).post("/logout", null, {
        headers: {
            Authorization: token
        }
    });
};
function validateRegisterForm(field, value, key) {
    var availableFields = [
        "fullname",
        "username",
        "password"
    ];
    if (availableFields.indexOf(field) < 0) {
        return Promise.reject(new Error("field is not available"));
    }
    return requestExodusNoError.post("/registration/check/".concat(field), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({
        key: key
    }, field, value));
}
/**
 * Forgot password request by email
 * @param {string} email - user email
 */ var forgotpassword = function(email) {
    return requestExodus.post("/user/setting/password/forgot", {
        email: email
    });
};
/**
 * Reset password
 * @param {string} userid - user id from link
 * @param {string} passkey - unique passkeyfrom link
 * @param {string} newpass - new password from form
 * @param {string} confirmpass - password confirmation from form
 *
 */ var resetPassword = function(userid, passkey, newpass, confirmpass) {
    return requestExodus.post("/user/setting/password/reset", {
        user_id: userid,
        token: passkey,
        password: newpass,
        confirm_password: confirmpass
    });
};
/**
 * Validate Social Media
 * @param {string} socialId
 * @param {string} socialToken
 * @param {string} email
 * @param {string} type
 * @returns {Promise<APIResponse>}
 */ var validateSocialMedia = function(socialId, socialToken, email, type) {
    return requestExodusNoError.post("/registration/check/sns-email", {
        social_id: socialId,
        social_token: socialToken,
        email: email,
        type: type
    });
};
var verifyRegistration = function(param) {
    var email = param.email, username = param.username, fullname = param.fullname, password = param.password, verificationToken = param.verificationToken;
    return requestExodusNoError.post("/registration/check/web", {
        email: email,
        username: username,
        fullname: fullname,
        password: password,
        verification_token: verificationToken
    });
};
/**
 * Verify Email Registration
 * @param {string} key
 * @param {string} email
 * @param {string} type
 * @returns {Promise<APIResponse>}
 */ var verifyEmailRegistration = function(key, email, type) {
    return requestExodusNoError.post("/registration/v3/check/email", {
        key: key,
        email: email,
        type: type
    });
};
/**
 * Valdidate Email OTP
 * @param {string} key
 * @param {string} otp
 * @returns {Promise<APIResponse>}
 */ var validateEmailOtp = function(key, otp) {
    return requestExodus.post("/registration/v3/otp/email", {
        key: key,
        otp: otp
    });
};
/**
 * Verify Phone Registration
 * @param {string} key
 * @param {string} code
 * @param {string} phone
 * @param {string} channel
 * @returns {Promise<APIResponse>}
 */ var verifyPhoneRegistration = function(key, code, phone, channel) {
    return _instances_exodus__WEBPACK_IMPORTED_MODULE_1__/* ["default"].noAlert.post */ .Z.noAlert.post("/registration/v3/check/phone", {
        key: key,
        code: code,
        phone: phone,
        channel: channel
    });
};
/**
 * Validate Phone OTP
 * @param {string} key
 * @param {string} otp
 * @returns {Promise<APIResponse>}
 */ var validatePhoneOtp = function(key, otp, headersFromNextjsAPI) {
    return authRequestExodus(headersFromNextjsAPI).post("/registration/v3/otp/phone", {
        key: key,
        otp: otp
    });
};
/**
 * Generate Registration Key
 * @returns {Promise<APIResponse>}
 */ var generateRegistrationKey = function() {
    return requestExodus.post("/registration/check/gen-key");
};
/* harmony default export */ __webpack_exports__["Z"] = ({
    emailLogin: emailLogin,
    fbLogin: fbLogin,
    googleLogin: googleLogin,
    logout: logout,
    validateRegisterForm: validateRegisterForm,
    forgotpassword: forgotpassword,
    resetPassword: resetPassword,
    // NEW REGISTARTION FLOW
    verifyRegistration: verifyRegistration,
    validateSocialMedia: validateSocialMedia,
    verifyEmailRegistration: verifyEmailRegistration,
    validateEmailOtp: validateEmailOtp,
    verifyPhoneRegistration: verifyPhoneRegistration,
    validatePhoneOtp: validatePhoneOtp,
    generateRegistrationKey: generateRegistrationKey
});


/***/ }),

/***/ 49431:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _number__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(62974);

var MAX_USERNAME_LENGTH = 17;
function normalUsername(name) {
    var draft = name.replace(/\s/g, "").toLowerCase();
    if (draft.length > MAX_USERNAME_LENGTH) {
        return draft.substr(0, MAX_USERNAME_LENGTH);
    }
    return draft;
}
function randomUsername(name) {
    var draft = normalUsername(name);
    var randomNumber = _number__WEBPACK_IMPORTED_MODULE_0__/* ["default"].getRandomInt */ .ZP.getRandomInt(1, 999);
    if (draft.length === MAX_USERNAME_LENGTH) {
        return "".concat(draft.substr(0, -3)).concat(randomNumber);
    }
    return "".concat(draft).concat(_number__WEBPACK_IMPORTED_MODULE_0__/* ["default"].getRandomInt */ .ZP.getRandomInt(1, 999));
}
/* harmony default export */ __webpack_exports__["Z"] = ({
    normalUsername: normalUsername,
    randomUsername: randomUsername
});


/***/ }),

/***/ 62974:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Q7": function() { return /* binding */ isFloat; },
/* harmony export */   "QV": function() { return /* binding */ roundNumber; },
/* harmony export */   "St": function() { return /* binding */ parseCountAbbrv2; },
/* harmony export */   "YA": function() { return /* binding */ parseNumberAbbrvNum; },
/* harmony export */   "ps": function() { return /* binding */ parseCountAbbrv3; },
/* harmony export */   "rl": function() { return /* binding */ formatPercentage; },
/* harmony export */   "uf": function() { return /* binding */ formatNumber; },
/* harmony export */   "ym": function() { return /* binding */ parseCountThousand; }
/* harmony export */ });
/* unused harmony exports kNumberFormatter, bNumberFormatter, decideNumberFormatter, parseCountThousandWithDecimalPlace, parsePureValueSep */
/* harmony import */ var numeral__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(92077);
/* harmony import */ var numeral__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(numeral__WEBPACK_IMPORTED_MODULE_0__);
/* eslint-disable no-param-reassign */ /* eslint-disable arrow-body-style */ /* eslint-disable radix */ 
/*
  Count length of given decimal
*/ function countLengthDecimal(num) {
    var match = "".concat(num).match(/(?:\.(\d+))?(?:[eE]([+-]?\d+))?$/);
    if (!match) {
        return 0;
    }
    return Math.max(0, // Number of digits right of decimal point.
    (match[1] ? match[1].length : 0) - // Adjust for scientific notation.
    (match[2] ? +match[2] : 0));
}
/*
  Get random integer from in range of min to max value
*/ function getRandomInt(min, max) {
    return Math.floor(Math.random() * (max - min + 1)) + min;
}
/**
 * Get total digit of a number
 * @param {number} num
 */ function getNumberDigit(num) {
    var netral = Math.abs(num);
    return netral.toString().length;
}
/**
 * Shorten thousands number
 * @param {number} num
 * @param {number} fixed
 * @param {boolean} symbol
 */ function kNumberFormatter(num) {
    var fixed = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 2, symbol = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false, withComa = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : false;
    var number;
    var nd = getNumberDigit(num);
    if (nd > 3) {
        number = (num / (nd > 5 ? 100000 : 1000)).toFixed(fixed);
        if (!withComa) {
            number = numeral__WEBPACK_IMPORTED_MODULE_0___default()(number).format("0,0");
        } else if (withComa) {
            number = numeral__WEBPACK_IMPORTED_MODULE_0___default()(number).format(typeof withComa === "string" ? withComa : "0,0.00");
        }
        if (symbol) {
            number += " K";
        }
    } else {
        number = num;
    }
    return number;
}
/**
 * Shorten long number and add suffix M
 * @param {number} num - Long number
 * @param {number} fixed - Decimal
 * @param {boolean} symbol - Flag to add symbol suffix
 */ function mNumberFormatter(num) {
    var fixed = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 2, symbol = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false;
    var number;
    var decide = false; // is decide need number
    if (getNumberDigit(num) > 6) decide = true;
    if (decide) {
        number = (num / 1000000).toFixed(fixed);
        if (symbol) {
            number += " M";
        }
    } else {
        number = num;
    }
    return number;
}
/**
 * Shorten long number and add suffix B
 * @param {number} num - Long number
 * @param {number} fixed - Decimal number
 * @param {boolean} symbol - Flag to add symbol suffix
 */ function bNumberFormatter(num) {
    var fixed = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 2, symbol = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false, formatDot = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : false;
    var number = (num / 1000000000).toFixed(fixed);
    if (symbol) {
        if (formatDot) {
            number = numeral__WEBPACK_IMPORTED_MODULE_0___default()(number).format("0.0");
        } else {
            number = numeral__WEBPACK_IMPORTED_MODULE_0___default()(number).format("0,0[.]0");
        }
        number += " B";
    }
    return number;
}
function tNumberFormatter(num) {
    var fixed = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 2, symbol = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false;
    var number = (num / 1000000000000).toFixed(fixed);
    if (symbol) {
        number = numeral__WEBPACK_IMPORTED_MODULE_0___default()(number).format("0.0");
        number += " T";
    }
    return number;
}
/**
 * Function to decide which number formatter should be used based on
 * the number length
 * @param {number} num
 * @param {boolean} withThousands
 * @param {boolean} formatDot
 */ function decideNumberFormatter(num, withThousands, formatDot) {
    var numberDigit = getNumberDigit(num);
    if (numberDigit > 12 && formatDot) return tNumberFormatter;
    if (numberDigit > 9) return bNumberFormatter;
    if (withThousands) {
        if (numberDigit > 6) return mNumberFormatter;
        return kNumberFormatter;
    }
    return mNumberFormatter;
}
/**
 * Number formatter wrapper
 * @param {Object} params
 * @param {*} params.num - Number to be formatted
 * @param {number} params.fixed - Decimal place
 * @param {boolean=} params.symbol - If formatted number has symbol suffix
 * @param {boolean=} params.withThousands - If decided to format thousands number
 * @param {*=} params.formatDot - Using dot in formatting
 * @returns {string | number} -formatted number
 */ function numberFormatter(param) {
    var num = param.num, fixed = param.fixed, _symbol = param.symbol, symbol = _symbol === void 0 ? true : _symbol, _withThousands = param.withThousands, withThousands = _withThousands === void 0 ? false : _withThousands, _formatDot = param.formatDot, formatDot = _formatDot === void 0 ? false : _formatDot;
    var formatter = decideNumberFormatter(num, withThousands, Boolean(formatDot));
    return formatter(num, fixed, symbol, formatDot);
}
var char_count = function(str, letter) {
    var letter_Count = 0;
    for(var position = 0; position < str.length; position += 1){
        if (str.charAt(position) === letter) {
            letter_Count += 1;
        }
    }
    return letter_Count;
};
var roundNumber = function(number, format) {
    var nFormat = format.split(".");
    var multiplier = 1;
    if (nFormat.length > 1) {
        var getDecimal = nFormat.pop();
        var decimal = char_count(getDecimal, "0");
        multiplier = Math.pow(10, decimal);
    }
    var nNumber = (number >= 0 ? Math.floor : Math.ceil)(number * multiplier) / multiplier;
    return nNumber;
};
var isFloat = function(n1) {
    return Number(n1) % 1 !== 0;
};
var processNumber = function(number, format, showTrailingZero) {
    var formattedNumber = numeral__WEBPACK_IMPORTED_MODULE_0___default()(number).format(format);
    var roundingNumber = formattedNumber;
    var splitNumber = formattedNumber.split(".");
    var isDecimal = splitNumber.length > 1;
    if (!showTrailingZero) {
        if (isDecimal) {
            roundingNumber = formattedNumber.replace(/(\.0+|0+)$/, "");
        } else if (splitNumber.length) {
            // eslint-disable-next-line prefer-destructuring
            roundingNumber = splitNumber[0];
        }
    }
    return roundingNumber;
};
var formatNumber = function(number) {
    var rounding = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : true, format = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : "0,0", showTrailingZero = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : false;
    var roundingNumber = rounding ? roundNumber(number, format) : number;
    var newNumber = processNumber(roundingNumber, format, showTrailingZero);
    return newNumber;
};
var formatPercentage = function(number) {
    var rounding = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : true, format = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : "0.00", showTrailingZero = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : false;
    if (number === Infinity) number = 0;
    var roundingNumber = rounding ? roundNumber(number, format) : number;
    var newNumber = processNumber(roundingNumber, format, showTrailingZero);
    return "".concat(newNumber, "%");
};
var parseLot = function(lot) {
    return Math.round(lot / 100);
};
var parseCountAbbrv3 = function(number, decPlaces) {
    var abbreviation = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 1, withDecimal = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : false, withMinusSymbol = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : false;
    var result = 0;
    var minus = false;
    var newNumber = number;
    // eslint-disable-next-line eqeqeq
    if (newNumber && newNumber.toString().indexOf("-") == 0) {
        minus = true;
    }
    newNumber = Math.ceil(newNumber);
    if (!decPlaces) decPlaces = 3;
    // 2 decimal places => 100, 3 => 1000, etc
    decPlaces = Math.pow(10, decPlaces);
    var abbrev;
    // Enumerate number abbreviations
    // eslint-disable-next-line default-case
    switch(abbreviation){
        case 1:
            // Enumerate number abbreviations
            abbrev = [
                "K",
                "M",
                "B",
                "T"
            ];
            break;
        case 2:
            // Enumerate number abbreviations
            abbrev = [
                "K",
                "M",
                "B"
            ];
            break;
        case 3:
            // Enumerate number abbreviations
            abbrev = [
                "K",
                "M"
            ];
            break;
        case 4:
            // Enumerate number abbreviations
            abbrev = [
                "K"
            ];
            break;
    }
    // Go through the array backwards, so we do the largest first
    // eslint-disable-next-line no-plusplus
    for(var i = abbrev.length - 1; i >= 0; i--){
        // Convert array index to "1000", "1000000", etc
        var size = Math.pow(10, (i + 1) * 3);
        // If the number is bigger or equal do the abbreviation
        if (size <= newNumber) {
            // Here, we multiply by decPlaces, round, and then divide by decPlaces.
            // This gives us nice rounding to a particular decimal place.
            newNumber = Math.round(newNumber * decPlaces / size) / decPlaces;
            // Handle special case where we round up to the next abbreviation
            if (newNumber === 1000 && i < abbrev.length - 1) {
                newNumber = 1;
                // eslint-disable-next-line no-plusplus
                i++;
            }
            var format = withDecimal ? "0,0[.]0" : "0,0";
            newNumber = numeral__WEBPACK_IMPORTED_MODULE_0___default()(newNumber).format(format);
            if (minus) {
                newNumber = withMinusSymbol ? "-".concat(newNumber) : "(".concat(newNumber, ")");
            }
            // Add the letter for the abbreviation
            newNumber += " ".concat(abbrev[i]);
            break;
        }
    }
    if (number) {
        var numString = newNumber.toString();
        result = numString;
    }
    return result;
};
var isNum = function(n1) {
    return !Number.isNaN(parseFloat(n1)) && Number.isFinite(n1);
};
var addPlusOrMinus2 = function(value) {
    if (!isNum(value)) {
        return value;
    }
    var formattedValue = numeral__WEBPACK_IMPORTED_MODULE_0___default()(value).value();
    var newValue = parseFloat(formattedValue);
    if (formattedValue !== 0) {
        newValue = formattedValue < 0 ? numeral__WEBPACK_IMPORTED_MODULE_0___default()(newValue).format("0,0") : "+".concat(numeral__WEBPACK_IMPORTED_MODULE_0___default()(newValue).format("0,0"));
    }
    return typeof newValue !== "string" ? String(newValue) : newValue;
};
var parseCountThousand = function(num, withdot) {
    var separator = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : ",";
    // let sep = ','
    try {
        if (withdot) {
            return num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, separator);
        }
        return removeCountDotThousand(num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, separator));
    } catch (e) {
        return num;
    }
};
var parseCountThousandWithDecimalPlace = function(num) {
    var decimalPlace = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 2;
    // let sep = ','
    try {
        return removeCountDotThousand(num.toLocaleString());
    } catch (e) {
        return num;
    }
};
function parsePureValueSep(pv) {
    var thoSep = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : ",";
    // console.log('::-- parsePureValue ', {pv, thoSep})
    if (typeof pv !== "number") pv = parseFloat(pv);
    return parseFloat(pv.toFixed(2)).toLocaleString("en-US");
}
var parseCountAbbrv2 = function(number, decPlaces) {
    var thoSep = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : ",", enableK = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : false;
    var result = 0;
    if (typeof decPlaces !== "number") decPlaces = 3;
    // 2 decimal places => 100, 3 => 1000, etc
    decPlaces = Math.pow(10, decPlaces);
    // Enumerate number abbreviations
    var abbrev = [
        "K",
        "M",
        "B"
    ];
    var oldNumber = number;
    // Go through the array backwards, so we do the largest first
    for(var i = abbrev.length - 1; i >= 0; i--){
        // Convert array index to "1000", "1000000", etc
        var size = Math.pow(10, (i + 1) * 3);
        // If the number is bigger or equal do the abbreviation
        if (size <= number) {
            // Here, we multiply by decPlaces, round, and then divide by decPlaces.
            // This gives us nice rounding to a particular decimal place.
            number = Math.round(number * decPlaces / size) / decPlaces;
            // Handle special case where we round up to the next abbreviation
            if (number == 1000 && i < abbrev.length - 1) {
                number = 1;
                i++;
            }
            // Add the letter for the abbreviation
            number += " ".concat(abbrev[i]);
            break;
        }
    }
    var raw = [];
    if (number) {
        number = number.toString();
        raw = number.split(" ");
        if (raw[0] && raw[1]) {
            // console.log('::-- row raw ', parsePureValueSep(raw[0], thoSep));
            result = parsePureValueSep(raw[0], thoSep);
            if (raw[1] === "K" && !enableK) {
                result = parseFloat(oldNumber);
                result = parsePureValueSep(result, thoSep);
            } else {
                result = "".concat(result, " ").concat(raw[1]);
            }
        } else {
            result = number;
        }
    }
    //   if(number) {
    // result = number.replace('.', ',')
    //   }
    return result;
};
function parseNumberAbbrvNum(val, format) {
    var number = numeral__WEBPACK_IMPORTED_MODULE_0___default()(val);
    var formatted = number.format(format);
    return formatted;
}
var parseCountAbbrv4 = function(param) {
    var value = param.value, decPlaces = param.decPlaces, _abbreviation = param.abbreviation, abbreviation = _abbreviation === void 0 ? 1 : _abbreviation, _withDecimal = param.withDecimal, withDecimal = _withDecimal === void 0 ? false : _withDecimal, _withMinusSymbol = param.withMinusSymbol, withMinusSymbol = _withMinusSymbol === void 0 ? false : _withMinusSymbol;
    return parseCountAbbrv3(value, decPlaces, abbreviation, withDecimal, withMinusSymbol);
};
/**
 * Shorten thousands number
 * @param {number} num
 * @param {number} fixed
 * @param {boolean} symbol
 * @param {boolean} withComma
 */ function kNumberFormatterV2(num) {
    var fixed = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 2, symbol = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false, withComma = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : false;
    var number;
    var nd = getNumberDigit(num);
    if (nd > 3) {
        number = (num / 1000).toFixed(fixed);
        if (!withComma) {
            number = numeral__WEBPACK_IMPORTED_MODULE_0___default()(number).format("0,0");
        } else {
            number = numeral__WEBPACK_IMPORTED_MODULE_0___default()(number).format(typeof withComma === "string" ? withComma : "0,0.0");
        }
        if (symbol) {
            number += " K";
        }
    } else {
        number = num;
    }
    return number;
}
var numberFormat = function(param) {
    var value = param.value, decimals = param.decimals, _decimalPoint = param.decimalPoint, decimalPoint = _decimalPoint === void 0 ? "." : _decimalPoint, _thousandSeparator = param.thousandSeparator, thousandSeparator = _thousandSeparator === void 0 ? "," : _thousandSeparator;
    //  discuss at: http://phpjs.org/functions/number_format/
    // original by: Jonas Raoni Soares Silva (http://www.jsfromhell.com)
    // improved by: Kevin van Zonneveld (http://kevin.vanzonneveld.net)
    // improved by: davook
    // improved by: Brett Zamir (http://brett-zamir.me)
    // improved by: Brett Zamir (http://brett-zamir.me)
    // improved by: Theriault
    // improved by: Kevin van Zonneveld (http://kevin.vanzonneveld.net)
    // bugfixed by: Michael White (http://getsprink.com)
    // bugfixed by: Benjamin Lupton
    // bugfixed by: Allan Jensen (http://www.winternet.no)
    // bugfixed by: Howard Yeend
    // bugfixed by: Diogo Resende
    // bugfixed by: Rival
    // bugfixed by: Brett Zamir (http://brett-zamir.me)
    //  revised by: Jonas Raoni Soares Silva (http://www.jsfromhell.com)
    //  revised by: Luke Smith (http://lucassmith.name)
    //    input by: Kheang Hok Chin (http://www.distantia.ca/)
    //    input by: Jay Klehr
    //    input by: Amir Habibi (http://www.residence-mixte.com/)
    //    input by: Amirouche
    //   example 1: number_format(1234.56);
    //   returns 1: '1,235'
    //   example 2: number_format(1234.56, 2, ',', ' ');
    //   returns 2: '1 234,56'
    //   example 3: number_format(1234.5678, 2, '.', '');
    //   returns 3: '1234.57'
    //   example 4: number_format(67, 2, ',', '.');
    //   returns 4: '67,00'
    //   example 5: number_format(1000);
    //   returns 5: '1,000'
    //   example 6: number_format(67.311, 2);
    //   returns 6: '67.31'
    //   example 7: number_format(1000.55, 1);
    //   returns 7: '1,000.6'
    //   example 8: number_format(67000, 5, ',', '.');
    //   returns 8: '67.000,00000'
    //   example 9: number_format(0.9, 0);
    //   returns 9: '1'
    //  example 10: number_format('1.20', 2);
    //  returns 10: '1.20'
    //  example 11: number_format('1.20', 4);
    //  returns 11: '1.2000'
    //  example 12: number_format('1.2000', 3);
    //  returns 12: '1.200'
    //  example 13: number_format('1 000,50', 2, '.', ' ');
    //  returns 13: '100 050.00'
    //  example 14: number_format(1e-8, 8, '.', '');
    //  returns 14: '0.00000001'
    var newNumber = value;
    var newDecimals = decimals;
    newNumber = "".concat(newNumber).replace(/[^0-9+\-Ee.]/g, "");
    var number = !isFinite(+newNumber) ? 0 : +newNumber;
    var prec = !isFinite(+newDecimals) ? 0 : Math.abs(newDecimals);
    var sep = thousandSeparator;
    var dec = decimalPoint;
    var sum = "";
    var toFixedFix = function toFixedFix(num, precision) {
        var power = Math.pow(10, precision);
        return "".concat((Math.round(num * power) / power).toFixed(precision));
    };
    // Fix for IE parseFloat(0.55).toFixed(0) = 0;
    sum = (prec ? toFixedFix(number, prec) : "".concat(Math.round(n))).split(".");
    if (sum[0].length > 3) {
        sum[0] = sum[0].replace(/\B(?=(?:\d{3})+(?!\d))/g, sep);
    }
    if ((sum[1] || "").length < prec) {
        sum[1] = sum[1] || "";
        sum[1] += new Array(prec - sum[1].length + 1).join("0");
    }
    return sum.join(dec);
};
var removeCountDotThousand = function(num) {
    if (!num.includes(".")) return num;
    num = numberFormat({
        value: num,
        decimals: 2
    });
    // pembulatan next index
    return num;
};
var isDecimal = function(result) {
    if (result > Math.floor(result)) {
        return true;
    }
    return false;
};
/* harmony default export */ __webpack_exports__["ZP"] = ({
    countLengthDecimal: countLengthDecimal,
    getRandomInt: getRandomInt,
    decideNumberFormatter: decideNumberFormatter,
    numberFormatter: numberFormatter,
    bNumberFormatter: bNumberFormatter,
    mNumberFormatter: mNumberFormatter,
    kNumberFormatter: kNumberFormatter,
    parseCountAbbrv3: parseCountAbbrv3,
    parseLot: parseLot,
    addPlusOrMinus2: addPlusOrMinus2,
    parseCountAbbrv4: parseCountAbbrv4,
    kNumberFormatterV2: kNumberFormatterV2,
    numberFormat: numberFormat,
    isDecimal: isDecimal
});


/***/ })

}]);